RivalIQ.module('apps', function (apps, App, Backbone, Marionette, $, _) {

    'use strict';

    const app = apps.MetricsExplorer = window.createMarionetteApp();
    app.name = 'MetricsExplorer';

});
